import React, { useEffect, useState } from "react";
import api from "../api";
import { Col, Container, Row } from "shards-react";
import {
  Button,
  CircularProgress,
  createMuiTheme,
  IconButton,
  MuiThemeProvider,
  TextField
} from "@material-ui/core";
import MUIDataTable from "mui-datatables";
import axios from "axios";
import Fab from "@material-ui/core/Fab";
import EditIcon from "@material-ui/icons/Edit";
import Tooltip from "@material-ui/core/Tooltip";
import AddIcon from "@material-ui/icons/Add";
import SearchIcon from "@material-ui/icons/Search";
import InputAdornment from "@material-ui/core/InputAdornment";
import FolderIcon from "@material-ui/icons/Folder";

const getMuiTheme = () =>
  createMuiTheme({
    overrides: {
      MuiTableCell: {
        root: {
          padding: "0px 8px 0px 8px",
          fontSize: "0.73rem"
        }
      },
      MuiFormLabel: {
        root: {
          fontSize: "0.75rem"
        }
      },
      MuiInputBase: {
        root: {
          fontSize: "0.75rem"
        }
      },
      MuiTypography: {
        body1: {
          fontSize: "0.75rem"
        }
      }
    }
  });

export const getColumns = (filterList, filterOptions) => [
  {
    name: "id",
    label: "Id",
    options: {
      filter: false,
      sort: true,
      display: true
    }
  },
  {
    name: "client.business_name",
    label: "Cliente",
    options: {
      filter: true,
      filterType: "textField",
      filterList: filterList
        .filter(f => f.key === "client.business_name")
        .map(f => f.value),
      sort: true,
      display: true
    }
  },
  {
    name: "plate.plate",
    label: "Patente",
    options: {
      filter: true,
      filterType: "textField",
      filterList: filterList
        .filter(f => f.key === "plate.plate")
        .map(f => f.value),
      sort: true,
      display: true
    }
  },
  {
    name: "subcontact.firstname",
    label: "Contacto Nombre",
    options: {
      filter: false,
      sort: false,
      display: false
    }
  },
  {
    name: "subcontact.lastname",
    label: "Contacto Apellido",
    options: {
      filter: false,
      sort: false,
      display: false
    }
  },
  {
    name: "booking_type_id",
    label: "Tipo",
    options: {
      filter: true,
      filterType: "select",
      filterOptions: {
        names: ["Flex", "Renting"]
      },
      customBodyRender: value => {
        if (value === 1) return "Flex";
        if (value === 2) return "Renting";
        return "";
      },
      sort: true,
      display: true
    }
  },
  {
    name: "status",
    label: "Estado",
    options: {
      filter: true,
      filterType: "select",
      filterList: filterList.filter(f => f.key === "status").map(f => f.value),
      filterOptions: [
        "borrador",
        "ingresada",
        "cancelada",
        "asignada",
        "check in",
        "alquilada",
        "asignar muleto",
        "check out",
        "revision",
        "finalizada"
      ],
      customBodyRender: (value, tableMeta, updateValue) => {
        const show_alert =
          tableMeta.rowData[14] &&
          tableMeta.rowData[14] >= 4 &&
          value != "alquilada"
            ? true
            : false;
        const styles = show_alert ? { color: "red" } : {};
        return (
          <span style={styles}>
            {show_alert == true && (
              <i class="text-danger font-weight-bold material-icons">warning</i>
            )}
            {value}
          </span>
        );
      },
      sort: true,
      display: true
    }
  },
  {
    name: "total_price",
    label: "Precio Total",
    options: {
      filter: true,
      filterType: "textField",
      sort: true,
      display: true
    },
    customBodyRender: value => {
      return "$" + value;
    }
  },
  {
    name: "start_date_fmt",
    label: "Fecha Inicio",
    options: {
      filter: false,
      filterType: "textField",
      sort: false,
      display: true
    }
  },
  {
    name: "end_date_fmt",
    label: "Fecha Fin",
    options: {
      filter: false,
      filterType: "textField",
      sort: false,
      display: true
    }
  },
  {
    name: "next_billing_date",
    label: "Fecha Próxima Facturación",
    options: {
      filter: false,
      filterType: "textField",
      sort: false,
      display: true
    }
  },
  {
    name: "user.name",
    label: "Usuario",
    options: {
      filter: false,
      filterType: "textField",
      sort: false,
      display: true
    }
  },
  {
    name: "relatedPlate.plate",
    label: "Vehículo Muleto",
    options: {
      filter: false,
      filterType: "textField",
      sort: false,
      display: true
    }
  },
  {
    name: "hansa_code",
    label: "Código Hansa",
    options: {
      filter: true,
      filterType: "textField",
      sort: false,
      display: true
    }
  },
  {
    name: "Acciones",
    label: "",
    options: {
      filter: false,
      setCellHeaderProps: () => ({ align: "center" }),
      customBodyRender: (value, tableMeta, updateValue) => {
        const rowId = tableMeta.rowData[0];
        return (
          <div className="row" style={{ display: "block" }}>
            {rowId ? (
              <Fab
                color="primary"
                aria-label="view"
                variant="extended"
                style={{ boxShadow: "none", backgroundColor: "green" }}
                fontSize="small"
                className="MuiButtonBase-root MuiFab-sizeSmall mr-2"
                href={"/booking/" + rowId}
              >
                <EditIcon fontSize="small" />
              </Fab>
            ) : (
              ""
            )}
          </div>
        );
      }
    }
  },
  {
    name: "days_from_last_change",
    label: "Días desde última modificación",
    options: {
      filter: false,
      sort: false,
      display: false,
      select: false,
      empty: true,
      viewColumns: false
    }
  }
];

const Bookings = () => {
  const [bookings, setBookings] = useState([]);
  const [filters, setFilters] = useState([{ key: "status", value: "" }]);
  const [q, setQ] = useState("");
  const [filterOptions, setFilterOptions] = useState({ status: [] });
  const [loading, setLoading] = useState(true);
  const [pagination, setPagination] = useState({
    page: 1,
    lastPage: 0,
    size: 10,
    total: 0,
    sort: "id",
    order: "desc"
  });
  const getBookings = async filterList => {
    const token = localStorage.getItem("userToken");
    var url = api.bookings().paginate();
    var params = `?page=${pagination.page}&q_rows=${pagination.size}`;
    if (filterList && filterList.length > 0) {
      filterList.forEach((value, idx) => {
        // get column name by getcolumns function
        const column = getColumns(filters, filterOptions)[idx];
        if (column && value && value.length > 0) {
          params += `&${column.name}=${value[0]}`;
        }
      });
    }
    url += params;
    if (q && q.length > 0) {
      url += `&q=${q}`;
    }
    return await axios
      .get(url, {
        headers: { Authorization: `Bearer ${token}` }
      })
      .then(res => {
        setBookings(res.data.data);
        setPagination({
          ...pagination,
          total: res.data.meta.total
        });
        setLoading(false);
      })
      .catch(err => {
        console.log(err);
      });
  };
  useEffect(() => {
    const getStates = async () => {
      const token = localStorage.getItem("userToken");
      return await axios
        .get(api.bookings().states(), {
          headers: { Authorization: `Bearer ${token}` }
        })
        .then(res => {
          setFilterOptions({ status: res.data });
        })
        .catch(err => {
          console.log(err);
        });
    };
    if (filterOptions.status.length === 0) getStates();
  }, [filterOptions]);

  useEffect(() => {
    const getBookingsEffect = async () => {
      await getBookings(q);
    };
    getBookingsEffect();
  }, [pagination.order, pagination.size, pagination.sort, pagination.page]);

  const options = {
    print: false,
    serverSide: true,
    page: pagination.page - 1,
    responsive: "stacked",
    selectableRowsOnClick: false,
    selectableRows: false,
    download: false,
    textLabels: {
      toolbar: {
        search: "Buscar",
        viewColumns: "Ver columnas",
        filterTable: "Filtros",
        downloadCsv: "Exportar XLS"
      },
      body: {
        noMatch: loading ? "No hay resultados" : <CircularProgress />
      },
      selectedRows: {
        text: "fila(s) seleccionadas"
      },
      viewColumns: {
        title: "Ver columnas"
      },
      pagination: {
        next: "Siguiente",
        previous: "Anteior",
        rowsPerPage: "Cantidad por página:",
        displayRows: "de"
      },
      filter: {
        all: "Todos",
        title: "Filtros",
        reset: "Limpiar"
      }
    },
    customToolbar: () => {
      return (
        <React.Fragment>
          <Tooltip title={"Nueva"}>
            <IconButton
              onClick={e => {
                window.location.href = "/booking/0";
              }}
            >
              <AddIcon />
            </IconButton>
          </Tooltip>
          <Tooltip title={"Importar cambios de precios"}>
            <IconButton
              onClick={e => {
                window.location.href = "bookings/price-changes/import";
              }}
            >
              <FolderIcon />
            </IconButton>
          </Tooltip>
        </React.Fragment>
      );
    },
    customFilterDialogFooter: filterList => {
      return (
        <div style={{ marginTop: "40px" }}>
          <Button
            variant="contained"
            onClick={() => {
              setLoading(true);
              setBookings([]);
              getBookings(filterList);
            }}
          >
            Aplicar
          </Button>
        </div>
      );
    },
    count: pagination.total,
    onFilterChange: (column, filterList, type) => {
      if (type === "chip") {
        this.handleFilterSubmit(this.state.page, filterList)();
      }
    },
    onChangeRowsPerPage: numberOfRows => {
      setLoading(true);
      setBookings([]);
      setPagination({ ...pagination, size: numberOfRows });
    },
    onColumnSortChange: (changedColumn, direction) => {
      let order = "desc";
      if (direction === "ascending") {
        order = "asc";
      }
      setPagination({ ...pagination, sort: changedColumn, order: order });
      setLoading(true);
    },
    onChangePage: page => {
      setPagination({ ...pagination, page: page + 1 });
      setLoading(true);
    },
    onSearchClose: () => {
      getBookings();
    },
    searchOpen: false,
    customSearchRender: (searchText, handleSearch, hideSearch, options) => {
      return (
        <React.Fragment>
          <TextField
            placeholder={"Buscar patente, numero de reserva o cliente..."}
            value={q || ""}
            onChange={e => {
              setQ(e.target.value);
              handleSearch(e.target.value);
            }}
            fullWidth={true}
            style={{ fontSize: "0.75rem" }}
            InputProps={{
              endAdornment: (
                <InputAdornment position="start">
                  <IconButton onClick={(() => handleSearch(""), hideSearch)}>
                    <SearchIcon />
                  </IconButton>
                </InputAdornment>
              )
            }}
            autoFocus
          />
        </React.Fragment>
      );
    }
  };

  return (
    <div>
      {loading ? (
        <div>
          <CircularProgress />
        </div>
      ) : (
        <Container fluid className="main-content-container px-4">
          <Row>
            <Col className="p-2">
              <div>
                <MuiThemeProvider theme={getMuiTheme()}>
                  <MUIDataTable
                    title="Lista de Reservas"
                    data={bookings}
                    columns={getColumns(filters, filterOptions)}
                    options={options}
                  />
                </MuiThemeProvider>
              </div>
            </Col>
          </Row>
        </Container>
      )}
    </div>
  );
};
export default Bookings;
